import { NavigationEnd, Router } from '@angular/router';
import { Component, ElementRef, Inject, Input, OnInit, AfterViewInit, ViewChild, ViewEncapsulation, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Constant } from 'src/app/constant/constant';
import { EmailHtmlNormalizerService } from 'src/app/services/email-html-normalizer.service';
import { takeUntil, filter, debounceTime, switchMap } from 'rxjs/operators';
import { CrmNoteService } from 'src/app/services/crm-note.service';
import { TemplatesService } from 'src/app/services/templates.service';
import { Subject } from 'rxjs';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { CustomFlexLayoutModule } from 'src/app/shared/flex-layout/custom-flex-layout.module';
import { DocEditorModule } from '../doc-editor/doc-editor.module';
import { MediaUploadModule } from 'src/app/pages/catalog/product/media-upload/media-upload.module';
import { SharedModule } from '../shared.module';
import { DirectiveModule } from '../directive/directive.module';
import { UsersService } from 'src/app/services/users.service';
import { CollaborationService } from 'src/app/services/collaboration.service';

@Component({
  standalone: true,
  selector: 'calsoft-crm-note',
  templateUrl: './crm-note.component.html',
  styleUrls: ['./crm-note.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    NgxMatSelectSearchModule,
    CustomFlexLayoutModule,
    DocEditorModule,
    MediaUploadModule,
    SharedModule,
    DirectiveModule
  ]
})
export class CrmNoteComponent implements OnInit, AfterViewInit, OnDestroy {

  sanitizedUrl: string = '';


  url = '';


  firstFormGroup: UntypedFormGroup;

  id: any;
  text: string;
  data: any;
  type: any = 1;
  activityId: number;


  activityType: any;
  noteId: any;
  note: any;
  Notetype: any;
  NoteTitle: any;

  crmType: any
  ownerId: any;

  // --- @mention state ---
  @ViewChild('notesTextarea') notesTextareaRef!: ElementRef<HTMLDivElement>;
  showMentionDropdown = false;
  mentionFilteredUsers: any[] = [];
  allUsers: any[] = [];
  mentionedUsers: any[] = [];
  notesFocused = false;
  showNotesError = false;
  private mentionSearch$ = new Subject<string>();
  private mentionQuery = '';
  private mentionStartIndex = -1;

  constructor(
    @Inject(MAT_DIALOG_DATA) data,
    private _formBuilder: UntypedFormBuilder,
    private snackBar: MatSnackBar,
    private dialogRef: MatDialogRef<CrmNoteComponent>,
    private crmNoteService: CrmNoteService,
    private templatesService: TemplatesService,
    private emailHtmlNormalizer: EmailHtmlNormalizerService,
    private router: Router,
    private usersService: UsersService,
    private collaborationService: CollaborationService
  ) {

    this.data = data;
    this.noteId = data['noteId'];
    this.note = data['note']
    this.Notetype = data['designType']
    this.NoteTitle = data['title']
    this.type = data['type'];
    this.crmType = data['crmType'];
    this.ownerId = data['ownerId'];
    this.url = this.router.url || '';
    this.router.events
      .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
      .subscribe(() => { this.url = this.router.url || ''; });
  }



  leadId: any;

  ngOnInit(): void {


    this.initNote();
    this.loadUsers();

    this.firstFormGroup.get("leadId").setValue(this.data['leadId']);

    this.text = "Save";

    if (this.noteId > 0) {

      this.editlead(this.note)
    } else {
      this.getTemplateTypeDownList();
    }

    this.firstFormGroup.patchValue({
      type: this.type
    });

  }

  ngAfterViewInit(): void {
    const el = this.notesTextareaRef?.nativeElement;
    if (el) {
      const initial = this.firstFormGroup.value.notes || '';
      el.textContent = initial;
    }
  }

  ngOnDestroy() {
    // calsoft-doc-editor handles its own cleanup
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  initNote() {
    this.firstFormGroup = this._formBuilder.group({
      noteId: [0],
      notes: [''],
      notesDocument: [''],
      leadId: [''],
      createdDate: [''],
      updatedDate: [''],
      createdBy: [''],
      updatedBy: [''],
      type: [''],
      taggedUser: [''],
      resource: [''],
      documentType: [''],
      template: []
    });
  }


  documentType: any = [
    { "value": "1", "viewValue": "Video" },
    { "value": "2", "viewValue": "Audio" },
    { "value": "3", "viewValue": "Pdf" },
    { "value": "4", "viewValue": "Image" },
  ]

  editlead(lead: any) {

    this.firstFormGroup = this._formBuilder.group({
      noteId: lead.noteId,
      notes: lead.notes,
      notesDocument: lead.notesDocument,
      leadId: lead.leadId,
      createdDate: lead.createdDate,
      updatedDate: lead.updatedDate,
      createdBy: lead.createdBy,
      updatedBy: lead.updatedBy,
      type: lead.type,
      taggedUser: lead.taggedUser,
      resource: lead.resource,
      documentType: lead.documentType,
    })


  }




  submitType() {

    this.dialogRef.close({ event: 'add', })

  }


  close() {
    this.dialogRef.close({ event: 'close' })
  }

  submit() {
    if (this.text == 'Save' && this.firstFormGroup.valid) {

      if (this.id != 0) {
        this.firstFormGroup.value.operationType = "Change"
      }
      else {
        this.firstFormGroup.value.operationType = "New"
      }


      if (this.firstFormGroup.value.notes == null || this.firstFormGroup.value.notes.toString().trim() == '') {
        this.showNotesError = true;
        this.snackBar.open("Notes cannot be blank", '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });

      } else {
        // Normalize HTML before saving
        try {
          let htmlNotes = (this.firstFormGroup.value.notes || '').toString();
          htmlNotes = this.emailHtmlNormalizer.normalizeHtmlForEmail(htmlNotes);

          // Remove amp; encoding artifact
          htmlNotes = htmlNotes.replace('amp;', '');

          this.firstFormGroup.value.notes = htmlNotes;
        } catch (e) {
          // ignore normalization errors
        }

        // Populate taggedUser from mentionedUsers before saving
        if (this.mentionedUsers.length > 0) {
          this.firstFormGroup.value.taggedUser = this.mentionedUsers.map((u: any) => u.userEmail).join(',');
        }

        this.text = "Processing"
        this.crmNoteService.addOrEditNote(this.firstFormGroup.value, this.type).subscribe(
          (response) => {
            if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
              this.text = "Save";
              this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });

              this.postMentionsAndShare(response);

              this.submitType();


            }
            else {
              this.text = "Save";
              this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
            }
          },
          () => { this.text = "Save" });
      }


    }
    else {
      this.firstFormGroup.markAllAsTouched();
    }
  }

  submitPayment() {
    if (this.text == 'Save' && this.firstFormGroup.valid) {

      if (this.id != 0) {
        this.firstFormGroup.value.operationType = "Change"
      }
      else {
        this.firstFormGroup.value.operationType = "New"
      }

      this.firstFormGroup.value.documentType = 5

      // Normalize HTML before saving
      try {
        let htmlNotes = (this.firstFormGroup.value.notes || '').toString();
        htmlNotes = this.emailHtmlNormalizer.normalizeHtmlForEmail(htmlNotes);

        // Remove amp; encoding artifact
        htmlNotes = htmlNotes.replace('amp;', '');

        this.firstFormGroup.value.notes = htmlNotes;
      } catch (e) {
        // ignore normalization errors
      }

      this.text = "Processing"
      this.crmNoteService.addOrEditNote(this.firstFormGroup.value, this.type).subscribe(
        (response) => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.text = "Save";
            this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });


            this.submitType();


          }
          else {
            this.text = "Save";
            this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
          }
        },
        () => { this.text = "Save" });
    }
    else {
      this.firstFormGroup.markAllAsTouched();
    }
  }


  getValue(event) {

    this.firstFormGroup.get('notesDocument').setValue(event);

  }

  // --- @mention methods ---

  onNotesInput(): void {
    const val = this.getEditorText();
    this.firstFormGroup.get('notes')!.setValue(val, { emitEvent: false });
    this.showNotesError = false;
  }

  private getEditorText(): string {
    const el = this.notesTextareaRef?.nativeElement;
    if (!el) return '';
    let text = '';
    el.childNodes.forEach((node: any) => {
      if (node.nodeType === Node.TEXT_NODE) {
        text += node.textContent || '';
      } else if (node.nodeName === 'BR') {
        text += '\n';
      } else {
        text += node.textContent || '';
      }
    });
    return text;
  }

  loadUsers(): void {
    this.usersService.getAllUserStatusDropDown().pipe(
      takeUntil(this._onDestroy)
    ).subscribe({
      next: (res: any) => {
        this.allUsers = Array.isArray(res) ? res : [];
        let index = this.allUsers.findIndex(x => x.entityId == this.ownerId);
        this.allUsers.splice(index, 1);
      },
      error: () => { this.allUsers = []; }
    });

    this.mentionSearch$.pipe(
      debounceTime(150),
      takeUntil(this._onDestroy)
    ).subscribe((q: string) => {
      const query = (q || '').toLowerCase();
      if (!query) {
        this.mentionFilteredUsers = this.allUsers;
      } else {
        this.mentionFilteredUsers = this.allUsers.filter(u =>
          u.email && u.email.toLowerCase().indexOf(query) > -1
        );
      }
      this.showMentionDropdown = this.mentionFilteredUsers.length > 0;
    });
  }

  onNotesKeyUp(event: KeyboardEvent): void {
    const ignored = ['ArrowUp', 'ArrowDown', 'Enter', 'Escape', 'Shift', 'Control', 'Alt', 'Meta'];
    if (ignored.includes(event.key)) return;

    const sel = window.getSelection();
    if (!sel || sel.rangeCount === 0) { this.showMentionDropdown = false; return; }

    const range = sel.getRangeAt(0);
    const preRange = range.cloneRange();
    preRange.selectNodeContents(this.notesTextareaRef.nativeElement);
    preRange.setEnd(range.endContainer, range.endOffset);
    const textBeforeCursor = preRange.toString();

    const atIndex = textBeforeCursor.lastIndexOf('@');
    if (atIndex !== -1) {
      const textAfterAt = textBeforeCursor.substring(atIndex + 1);
      if (!textAfterAt.includes(' ') && !textAfterAt.includes('\n')) {
        this.mentionQuery = textAfterAt;
        this.mentionStartIndex = atIndex;
        this.mentionSearch$.next(textAfterAt);
        return;
      }
    }
    this.showMentionDropdown = false;
    this.mentionQuery = '';
    this.mentionStartIndex = -1;
  }

  onNotesBlur(): void {
    this.notesFocused = false;
    this.showMentionDropdown = false;
  }

  onOptionMousedown(event: MouseEvent, user: any): void {
    event.preventDefault();
    this.selectMentionUser(user);
  }

  selectMentionUser(user: any): void {
    const el = this.notesTextareaRef?.nativeElement;
    if (!el) return;

    el.focus();
    const sel = window.getSelection();

    let targetNode: Node;
    let curOffset: number;

    if (sel && sel.rangeCount > 0) {
      const range = sel.getRangeAt(0);
      targetNode = range.endContainer;
      curOffset = range.endOffset;
    } else {
      // fallback: append at end
      targetNode = el;
      curOffset = el.childNodes.length;
    }

    // If cursor is on the div itself (not a text node), create a text node first
    if (targetNode === el || targetNode.nodeType !== Node.TEXT_NODE) {
      const textNode = document.createTextNode('');
      el.appendChild(textNode);
      targetNode = textNode;
      curOffset = 0;
    }

    const charsToDelete = this.mentionQuery.length + 1; // +1 for @
    const deleteStart = Math.max(0, curOffset - charsToDelete);
    const deleteRange = document.createRange();
    deleteRange.setStart(targetNode, deleteStart);
    deleteRange.setEnd(targetNode, curOffset);
    deleteRange.deleteContents();

    // Create highlighted chip
    const chip = document.createElement('span');
    chip.className = 'mention-chip';
    chip.setAttribute('contenteditable', 'false');
    chip.textContent = '@' + user.email;
    chip.dataset['userId'] = String(user.entityId);
    deleteRange.insertNode(chip);

    // Space after chip for continued typing
    const space = document.createTextNode('\u00A0');
    chip.after(space);

    if (sel) {
      const newRange = document.createRange();
      newRange.setStartAfter(space);
      newRange.collapse(true);
      sel.removeAllRanges();
      sel.addRange(newRange);
    }

    this.onNotesInput();

    if (!this.mentionedUsers.find((m: any) => m.userId === user.entityId)) {
      this.mentionedUsers.push({
        userId: user.entityId,
        userName: user.email,
        userEmail: user.email,
        mentionedBy: null,
        mentionedByName: this.firstFormGroup.value.createdBy || ''
      });
    }

    this.showMentionDropdown = false;
    this.mentionQuery = '';
    this.mentionStartIndex = -1;
  }

  private postMentionsAndShare(response: any): void {
    if (!this.mentionedUsers.length) return;
    const savedNoteId = response?.data?.noteId ?? response?.noteId;
    const resourceType = this.getResourceType();
    const resourceId = this.firstFormGroup.value.leadId;

    if (savedNoteId && resourceId) {
      this.collaborationService.saveMentions(
        'NOTE', savedNoteId, resourceType, resourceId, this.mentionedUsers
      ).subscribe({ error: () => { } });
    }

    this.mentionedUsers.forEach((mu: any) => {
      if (mu.userId && resourceId) {
        this.collaborationService.shareResource({
          resourceType,
          resourceId,
          userId: mu.userId,
          userName: mu.userName,
          sharedBy: 0
        }).subscribe({ error: () => { } });
      }
    });
  }

  private getResourceType(): string {
    if (this.type == 2) return 'COMPANY';
    if (this.type == 3) return 'DEAL';
    return 'LEAD';
  }

  //ActivityType

  filteredTemplateTypeList: any;

  templateTypeList: any;
  templateList: any;

  protected _onDestroy = new Subject<void>();


  public typeYFilterControl: UntypedFormControl = new UntypedFormControl();

  getTemplateTypeDownList() {

    this.templatesService.getAllTemplatesDropDown().subscribe(
      res => {
        this.templateList = res;
        this.templateTypeList = res;
        this.filteredTemplateTypeList = this.templateTypeList;
      },
      error => {
      })
  }


  TemplateTypeYFilter() {
    this.typeYFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.typeTemplateTypeYFilter();
      });
  }


  protected typeTemplateTypeYFilter() {
    if (!this.templateTypeList) {
      return;
    }
    let search = this.typeYFilterControl.value;
    if (!search) {
      this.filteredTemplateTypeList = this.templateTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredTemplateTypeList = this.templateTypeList.filter(source => source['templateName'].toLowerCase().indexOf(search) > -1)
  }

  getAllActivityTypedropdowntype() {
    this.filteredTemplateTypeList = this.templateTypeList;
  }

  setTemplate(event, opt) {

    if (event.isUserInput != false) {

      let value = opt.templateJson;

      this.firstFormGroup.get("notes").setValue(value);

    }

  }


  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }
}